module.exports = __webpack_public_path__ + "static/media/worker-subcontractor.70403194.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/worker-subcontractor.svg
// module id = 287
// module chunks = 36